import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { HelperService } from 'app/services/helper.service';
import { DmsAccessService } from "../services/dms-access.service";
import { DownloadService } from "../services/download.service";

@Component({
  selector: 'app-questionnaire-popup',
  templateUrl: './questionnaire-popup.component.html',
  styleUrls: ['./questionnaire-popup.component.scss'],
  providers: [DownloadService, DmsAccessService]
})
export class QuestionnairePopupComponent implements OnInit {
  public questionnaires: any = [];
  public survey: any = [];
  public dbData: any = [];
  public dbDataOfSurvey: any = [];
  constructor(public bsModalRef: BsModalRef,
    private dmsAccessService: DmsAccessService,
    private downloadService: DownloadService,
    private helperService: HelperService) { }

  ngOnInit() {
    setTimeout(() => {
      this.questionnaires.forEach(element => {
        this.getAllDocuments(element.id, 1);
      });
      this.survey.forEach(element => {
        this.getAllDocuments(element.id, 2);
      });
    }, 2);
  }

  public getAllDocuments(questionaireID, type) {
    const that = this;
    const item: any = [];
    item.companySystemID = that.helperService.getSelectedCompanyId();
    item.documentSystemCode = questionaireID;
    item.documentSystemID = (type == 1) ? 21 : 23;
    that.dmsAccessService
      .getAllcommonFilesWeb()
      .get(item)
      .subscribe((resp) => {
        if (type == 1) {
          this.dbData[questionaireID] = resp.data.data.master;
        } else {
          this.dbDataOfSurvey[questionaireID] = resp.data.data.master;
        }
      }, (error) => {
      });
  }

  public dmsFile(item) {
    this.dmsAccessService.downloadDocument2(item.attachmentID, item.fileNameWithExtenstion);
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  goToQuiz(questionaireID) {
    this.bsModalRef.hide();
    this.helperService.go('questionnaire/attempt/' + questionaireID);
  }

  goToSurvey(surveyID) {
    this.bsModalRef.hide();
    this.helperService.go('survey-management/attempt/' + surveyID);
  }
}



// WEBPACK FOOTER //
// /app/src/app/questionnaire-popup/questionnaire-popup.component.ts